import States from '../../../../constants/States';

const stateAbbrs = Object.keys(States) as (keyof typeof States)[];
const stateValues = Object.values(States).map((x) => x.toLowerCase());

export function getStateAbbr(state: string) {
    const normalState = state.replaceAll('_', ' ').toLocaleLowerCase();
    const valueIndex = stateValues.indexOf(normalState);
    return stateAbbrs[valueIndex] || state;
}

export function formatStateName(state: string) {
    return state
        .replaceAll('_', ' ')
        .split(' ')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
}

export function parseJobTypeLabels(jobType?: string): string[] {
    return jobType ? jobType.split(',').map((t) => t.trim()) : ['Full Time', 'Part Time'];
}
